(function () {
    "use strict";

    if (!Array.prototype.inArray) {
        Array.prototype.inArray = function (value, caseSensitive) {
            var i;
            for (i = 0; i < this.length; i++) {
                if (caseSensitive) {
                    if (this[i].toLowerCase() == value.toLowerCase()) {
                        return true;
                    }
                } else {
                    if (this[i] == value) {
                        return true;
                    }
                }
            }
            return false;
        };
    }
})();


// WEBPACK FOOTER //
// ./content/js/PrototypeExtensions/Array.inArray.js